import { DatePicker } from 'antd'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useRequest } from 'ahooks'
import { getProjectStartEndDateApi } from 'api'
import { getProjectDateRange } from 'utils'
import moment from 'moment'
import './DatePicker.scss'

export const ChooseDatePicker = ({ value, onChange, item, types, flag }) => {
    const [date, setDate] = useState()
    const [projectData, setProjectData] = useState(null)
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const projectId = userInfo?.user?.projectId

    const handleChange = date => {
        setDate(date)
    }

    /* 项目开始结束日期接口 */
    const { run: getProjectStartEndDate } = useRequest(projectId => getProjectStartEndDateApi(projectId), {
        manual: true,
        onSuccess: data => {
            setProjectData(data)
        },
    })

    useEffect(() => {
        if (!projectId) return
        getProjectStartEndDate(projectId)
    }, [projectId])

    useEffect(() => {
        if (!value) return
        setDate(moment(value, 'YYYY-MM-DD'))
    }, [])

    useEffect(() => {
        onChange(date?.format('YYYY-MM-DD'))
    }, [date])

    return (
        <DatePicker
            format='YYYY-MM-DD'
            className='date'
            value={date}
            onChange={handleChange}
            allowClear={true}
            placeholder=''
            disabledDate={currentDate => {
                if (!projectData) return
                // 项目开始日期
                const { startDate, endDate } = getProjectDateRange(projectData?.data?.data)
                const date = currentDate.format('YYYY-MM-DD')
                return date < startDate || date > endDate
            }}
        />
    )
}
